import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TagComponent from "@meetyoo/components/src/components/Tag";
import { defaultPasscodeTheme } from "../../../../constants/passCodeUtils";
import EditModalWarning from "../Modal/EditModalWarning";
import { spliceTag } from "../../../../utils/objectMethods/tagOperations";
import TableLayoutActions from "./TableLayoutActions";
import TableConfigurator from "./TableConfigurator";
import Cell from "./TableCell";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  field: { padding: theme.spacing(0, 2, 0, 2) },
  ellipsis: {
    textOverflow: "clip  ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "pointer",
    maxWidth: "420px", // noice
  },
  noEllipsis: {
    maxWidth: "420px", // noice
  },
  pointer: {
    cursor: "pointer",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "750px",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  inline: {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "wrap",
  },
  toolTipFontSize: {
    fontSize: "0.7rem",
  },
  tooltipMargin: {
    margin: theme.spacing(0),
  },
  tag: {
    padding: theme.spacing(0, 0.25),
    paddingTop: "2px",
  },
  box: {
    width: theme.spacing(1),
    height: theme.spacing(1),
  },
  circle: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: "50%",
    fontWeight: "bold",
    display: "flex",
  },
  unprocessedTicket: {
    background: "#66CC33",
  },
  updatedTicket: {
    background: "#bfbf00",
  },
  inlineTitle: {
    display: "flex",
  },
  bold: {
    fontWeight: "bold",
  },
}));

export const TableLayoutComponent = ({ row, colorMap, setOpenFilter, type, tableLayout, setFilter, username }) => {
  const classes = useStyles();
  const [titleClicked, setTitleClicked] = useState(false);
  const [openModalWarning, setOpenModalWarning] = useState(false);

  // const boldTitle = () => {
  //   // bold when no owner is set
  //   if (row.owner === "" || row.owner === "-") return true;
  //   // no bold title when owner is set and user is not owner
  //   if (row.owner !== "" && row.owner !== "-" && row.owner !== username) return false;
  //   // prevent bold when email is send out
  //   // last contact in any direction doesn`t equal last contact last contact from us
  //   // last contact from us shouldn`t be 0 (setting corvered tag will change this)
  //   // when all above is true it returns true
  //   if (
  //     !row.updatedBy.includes("@meetyoo") &&
  //     row.lastContactAgentAt !== row.lastContactAt &&
  //     row.lastContactAgentAt !== 0
  //   )
  //     return true;
  //   // bold when there was an answer and customer contact was earlier than any update from owner (note, changing order id etc) needs to be tested
  //   // if (row.lastContactCustomerAt > row.lastOwnerUpdateAt && row.lastContactCustomerAt !== 0) return true;
  //   return false;
  // };

  return [
    <TableRow key="ticket-data" id={row.id} hover tabIndex={0}>
      <TableLayoutActions type={type} row={row} setOpenModal={setOpenModalWarning} />
      <TableCell
        onClick={() => setTitleClicked(!titleClicked)}
        className={`${classes.field} ${!titleClicked ? classes.ellipsis : classes.noEllipsis}`}
        id={row.title}
        padding="none"
      >
        <div className={`${classes.inlineTitle}`}>{row.title}</div>
        <div className={classes.inline}>
          {row.tags.map((item, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={item + idx} className={classes.tag}>
              <TagComponent key={item} text={spliceTag(item)} color={colorMap[spliceTag(item)]} />
            </div>
          ))}
        </div>
      </TableCell>
      {tableLayout.map(item => {
        return item !== "title" ? (
          <Cell
            key={"cell " + item}
            value={row[item]}
            item={item}
            toolTip={
              TableConfigurator[item].toolTip && TableConfigurator[item].value(row[item]) !== -1
                ? TableConfigurator[item].toolTip(row[item])
                : undefined
            }
            type={TableConfigurator[item].type}
            onClickSearch={
              TableConfigurator[item].onClickSearch && !(type === "closed" && item === "webcastID")
                ? () => {
                    setOpenFilter(true);
                    setFilter(row[item], [item]);
                  }
                : undefined
            }
          />
        ) : null;
      })}
    </TableRow>,
    <EditModalWarning
      key="edit-modal-warning"
      row={row}
      setOpenModal={() => setOpenModalWarning(false)}
      openModal={openModalWarning}
    />,
  ];
};

TableLayoutComponent.defaultProps = {
  filterObject: undefined,
};

TableLayoutComponent.propTypes = {
  row: PropTypes.object.isRequired,
  colorMap: PropTypes.object.isRequired,
  setOpenFilter: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  tableLayout: PropTypes.array.isRequired,

  username: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  colorMap: state.projectmail.colorMap,
  lastWorkedTicket: state.projectmail.lastWorkedTicket,
  tableLayout: state.projectmail.tableLayout[ownProps.type],
  username: state.oauth.username,
});
const TableLayout = connect(mapStateToProps)(TableLayoutComponent);

export default TableLayout;
